import { render } from "./StepsLayout.vue?vue&type=template&id=61d8aff6&scoped=true"
import script from "./StepsLayout.vue?vue&type=script&lang=js"
export * from "./StepsLayout.vue?vue&type=script&lang=js"

import "./StepsLayout.vue?vue&type=style&index=0&id=61d8aff6&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d8aff6"]])

export default __exports__